export const removeAccents = str => {
    if (!str) return ''

    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export const normalize = str => removeAccents(str).toLowerCase()

export const isEmpty = str => !str || str.trim().length === 0
